"use client";

import { Button } from "@/components/ui/Button";

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  itemTitle: string;
  itemId: string;
  onRemoveItem: (itemId: string) => void;
  onCancel: () => void;
  onSaveForLater?: (itemId: string, itemTitle: string) => void;
}

export function DeleteConfirmationDialog({
  isOpen,
  itemTitle,
  itemId,
  onRemoveItem,
  onCancel,
  onSaveForLater
}: DeleteConfirmationDialogProps) {
  if (!isOpen) return null;

  const handleSaveForLater = () => {
    if (onSaveForLater) {
      onSaveForLater(itemId, itemTitle);
    } else {
      // Default behavior: just log for now
      console.log(`Saved ${itemTitle} for later`);
    }
    onRemoveItem(itemId);
    onCancel();
  };

  const handleRemoveItem = () => {
    onRemoveItem(itemId);
    onCancel();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Remove "{itemTitle}"?
        </h3>
        <p className="text-gray-600 mb-6">
          Are you sure you want to remove this item from your cart?
        </p>
        <div className="flex gap-3">
          <Button
            variant="outline"
            onClick={handleSaveForLater}
            className="flex-1"
          >
            Save for Later
          </Button>
          <Button
            variant="destructive"
            onClick={handleRemoveItem}
            className="flex-1"
          >
            Remove Item
          </Button>
        </div>
        <Button
          variant="ghost"
          onClick={onCancel}
          className="w-full mt-2"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}
